import React from 'react';
import { UsersIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
};
export function ScarcityBar({
  tone = 'light'
}: ScarcityBarProps) {
  const isDark = tone === 'dark';
  return <div className="w-full max-w-md" data-id="element-52" data-mp="2l3v2qogp2a6w">
      <div className={`flex items-center justify-center gap-2 text-center text-[13px] font-bold sm:text-sm ${isDark ? 'text-white' : 'text-[#B4442F]'}`} data-id="element-53" data-mp="2l2tqwhrutjo4">
        <UsersIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-54" data-mp="2b5fa2h20qsva" />
        <span data-id="element-55" data-mp="2g6w9s98ro9aa">Restano solo 9 posti al prezzo di lancio</span>
      </div>
      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/15' : 'bg-[#E4DCCE]'}`} role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Posti riservati al prezzo di lancio" data-id="element-56" data-mp="226bs5gel8jid">
        <div className="h-full rounded-full bg-[#B4442F]" style={{
        width: '93%'
      }} data-id="element-57" data-mp="5e1tug890pwe" />
      </div>
      <p className={`mt-2 text-center text-[11.5px] font-semibold uppercase tracking-[0.08em] ${isDark ? 'text-white/70' : 'text-[#4A6B70]'}`} data-id="element-58" data-mp="33lk3kl55a5f5">
        111 posti su 120 già riservati · 93% completato
      </p>
    </div>;
}